var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserAccountHexagon = function SvgUserAccountHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 85,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0C9E2",
    stroke: "url(#userAccountHexagon_svg__a)",
    strokeWidth: 1.8,
    d: "M39.65 2.415a4.7 4.7 0 0 1 4.7 0L75.123 20.18a4.7 4.7 0 0 1 2.35 4.07v35.534a4.7 4.7 0 0 1-2.35 4.07L44.35 81.622a4.7 4.7 0 0 1-4.7 0L8.877 63.855a4.7 4.7 0 0 1-2.35-4.07V24.252a4.7 4.7 0 0 1 2.35-4.07z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#004280",
    d: "M42 63.5c11.874 0 21.5-9.626 21.5-21.5S53.874 20.5 42 20.5 20.5 30.126 20.5 42 30.126 63.5 42 63.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M32 42c0-3.771 0-5.657 1.172-6.828S36.229 34 40 34h4c3.771 0 5.657 0 6.828 1.172S52 38.229 52 42s0 5.657-1.172 6.828S47.771 50 44 50h-4c-3.771 0-5.657 0-6.828-1.172S32 45.771 32 42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M41 40a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M43 46a4 4 0 0 0-8 0M45 39h4M45 42h4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "userAccountHexagon_svg__a",
    x1: 42,
    x2: 42,
    y1: 0.018,
    y2: 84.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#011427"
  })))));
};
export default SvgUserAccountHexagon;